module.exports = __webpack_public_path__ + "img/search.27cdfb0f.svg";